module.exports = __webpack_public_path__ + "img/microsoftIcon.5581f5f8.svg";